import { gql } from '@apollo/client';

export interface DeleteActivityAnswerMutationVariables {
  courseId: string;
  activityId: string;
  answerId: string;
}

export interface DeleteActivityAnswerMutationResult {
  answer: {
    id: string;
  };
}

export const deleteActivityAnswerMutation = gql`
  mutation DeleteActivityAnswerMutation($courseId: String!, $activityId: String!, $answerId: String!) {
    answer(courseId: $courseId, activityId: $activityId, answerId: $answerId)
      @rest(type: "ActivityAnswer", path: "courses/{args.courseId}/activities/{args.activityId}/answers/{args.answerId}", method: "DELETE") {
      id
    }
  }
`;
